module.exports = __webpack_public_path__ + "static/media/disconnect-button.592a0b07.svg";